import * as React from 'react';

import { Props as IconProps } from 'components/Icon';
import SVGBase from 'components/SVGBase';

const ArrowRight: React.FC<IconProps> = ({ ...props }) => {
  return (
    <SVGBase {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 16C2 15.4477 2.44772 15 3 15H27C27.5523 15 28 15.4477 28 16C28 16.5523 27.5523 17 27 17H3C2.44772 17 2 16.5523 2 16Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2929 3.29289C15.6834 2.90237 16.3166 2.90237 16.7071 3.29289L28.7071 15.2929C29.0976 15.6834 29.0976 16.3166 28.7071 16.7071L16.7071 28.7071C16.3166 29.0976 15.6834 29.0976 15.2929 28.7071C14.9024 28.3166 14.9024 27.6834 15.2929 27.2929L26.5858 16L15.2929 4.70711C14.9024 4.31658 14.9024 3.68342 15.2929 3.29289Z"
        fill={props.color}
      />
    </SVGBase>
  );
};

const BellBlue: React.FC<IconProps> = ({ ...props }) => {
  return (
    <SVGBase {...props} viewBox="0 0 28 28">
      <path
        d="M27 20.5H1a3.9 3.9 0 0 0 3.9-3.9v-6.5a9.1 9.1 0 1 1 18.2 0v6.5a3.9 3.9 0 0 0 3.9 3.9Z"
        style={{ fill: '#7CBFFE', fillRule: 'evenodd' }}
      />
      <path d="M16.75 24.835a1 1 0 0 0-1.366.363 1.6 1.6 0 0 1-2.768 0 1 1 0 0 0-1.73 1.004 3.6 3.6 0 0 0 6.228 0 1 1 0 0 0-.363-1.367ZM27 19.5a2.9 2.9 0 0 1-2.9-2.9v-6.5C24.1 4.522 19.578 0 14 0S3.9 4.522 3.9 10.1v6.5A2.9 2.9 0 0 1 1 19.5a1 1 0 1 0 0 2h26a1 1 0 1 0 0-2Zm-22.07 0c.602-.814.97-1.81.97-2.9v-6.5a8.1 8.1 0 1 1 16.2 0v6.5c0 1.09.368 2.086.97 2.9H4.93Z" />
    </SVGBase>
  );
};

const Download: React.FC<IconProps> = ({ ...props }) => {
  return (
    <SVGBase {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 18.6667C5.55228 18.6667 6 19.1144 6 19.6667V24.5556C6 25.3533 6.6467 26 7.44444 26H24.5556C25.3533 26 26 25.3533 26 24.5556V19.6667C26 19.1144 26.4477 18.6667 27 18.6667C27.5523 18.6667 28 19.1144 28 19.6667V24.5556C28 26.4579 26.4579 28 24.5556 28H7.44444C5.54213 28 4 26.4579 4 24.5556V19.6667C4 19.1144 4.44772 18.6667 5 18.6667Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.18178 12.8484C9.57231 12.4579 10.2055 12.4579 10.596 12.8484L16 18.2525L21.404 12.8484C21.7945 12.4579 22.4277 12.4579 22.8182 12.8484C23.2087 13.239 23.2087 13.8721 22.8182 14.2627L16.7071 20.3738C16.3166 20.7643 15.6834 20.7643 15.2929 20.3738L9.18178 14.2627C8.79126 13.8721 8.79126 13.239 9.18178 12.8484Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 4C16.5523 4 17 4.44772 17 5V19.6667C17 20.219 16.5523 20.6667 16 20.6667C15.4477 20.6667 15 20.219 15 19.6667V5C15 4.44772 15.4477 4 16 4Z"
        fill={props.color}
      />
    </SVGBase>
  );
};

const Ellipses: React.FC<IconProps> = ({ ...props }) => {
  return (
    <SVGBase {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16C8 17.6569 6.65685 19 5 19C3.34315 19 2 17.6569 2 16C2 14.3431 3.34315 13 5 13C6.65685 13 8 14.3431 8 16ZM19 16C19 17.6569 17.6569 19 16 19C14.3431 19 13 17.6569 13 16C13 14.3431 14.3431 13 16 13C17.6569 13 19 14.3431 19 16ZM27 19C28.6569 19 30 17.6569 30 16C30 14.3431 28.6569 13 27 13C25.3431 13 24 14.3431 24 16C24 17.6569 25.3431 19 27 19Z"
        fill={props.color}
      />
    </SVGBase>
  );
};

const EllipsesAnimated: React.FC<IconProps> = ({ ...props }) => {
  return (
    <SVGBase {...props} viewBox="0 0 32 32">
      <rect x="0" y="11" width="8" height="12" fill="#656565">
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="1; .2; 1"
          begin="0s"
          dur="0.6s"
          repeatCount="indefinite"
        />
      </rect>
      <rect x="12" y="11" width="8" height="12" fill="#656565">
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="1; .2; 1"
          begin="0.2s"
          dur="0.6s"
          repeatCount="indefinite"
        />
      </rect>
      <rect x="24" y="11" width="8" height="12" fill="#656565">
        <animate
          attributeName="opacity"
          attributeType="XML"
          values="1; .2; 1"
          begin="0.4s"
          dur="0.6s"
          repeatCount="indefinite"
        />
      </rect>
    </SVGBase>
  );
};

const EyeOff: React.FC<IconProps> = ({ ...props }) => {
  return (
    <SVGBase {...props} viewBox="0 0 32 32">
      <path
        d="M23.6262 23.8154C24.0654 23.4806 24.1501 22.8531 23.8153 22.4139C23.4805 21.9746 22.853 21.89 22.4138 22.2248L23.6262 23.8154ZM16 25.4546V26.4546C16.0054 26.4546 16.0109 26.4546 16.0163 26.4545L16 25.4546ZM3 16.0001L2.11884 15.5273C1.96521 15.8136 1.96026 16.1567 2.10557 16.4473L3 16.0001ZM9.5869 9.77486C10.0258 9.43968 10.11 8.81212 9.77478 8.37318C9.43959 7.93424 8.81204 7.85012 8.3731 8.1853L9.5869 9.77486ZM13.2904 5.85546C12.7526 5.98133 12.4187 6.5193 12.5446 7.05705C12.6705 7.5948 13.2085 7.92869 13.7462 7.80282L13.2904 5.85546ZM16.0001 6.5455L15.9978 7.5455H16.0001V6.5455ZM29.0001 16L29.882 16.4715C30.0349 16.1854 30.0396 15.8429 29.8945 15.5528L29.0001 16ZM25.6822 19.1262C25.3266 19.5488 25.381 20.1796 25.8035 20.5352C26.2261 20.8908 26.857 20.8365 27.2125 20.4139L25.6822 19.1262ZM19.237 19.1872C19.6135 18.7831 19.5912 18.1504 19.1871 17.7739C18.7831 17.3974 18.1503 17.4197 17.7738 17.8238L19.237 19.1872ZM14.1762 14.2262C14.5803 13.8497 14.6026 13.2169 14.2261 12.8128C13.8496 12.4088 13.2168 12.3865 12.8128 12.763L14.1762 14.2262ZM22.4138 22.2248C20.5633 23.6353 18.3101 24.4167 15.9836 24.4548L16.0163 26.4545C18.7696 26.4095 21.4362 25.4847 23.6262 23.8154L22.4138 22.2248ZM16 24.4546C12.2631 24.4546 9.25915 22.3174 7.12726 20.0434C6.07044 18.9161 5.25703 17.785 4.70794 16.9348C4.43401 16.5107 4.2275 16.159 4.09086 15.9161C4.02257 15.7947 3.97185 15.7006 3.93899 15.6385C3.92256 15.6075 3.91061 15.5844 3.90316 15.57C3.89944 15.5627 3.89685 15.5576 3.89539 15.5548C3.89466 15.5533 3.89422 15.5524 3.89406 15.5521C3.89398 15.552 3.89397 15.5519 3.89403 15.5521C3.89406 15.5521 3.89416 15.5523 3.89417 15.5524C3.89429 15.5526 3.89443 15.5529 3 16.0001C2.10557 16.4473 2.10574 16.4476 2.10593 16.448C2.10602 16.4482 2.10623 16.4486 2.1064 16.4489C2.10675 16.4496 2.10718 16.4505 2.10767 16.4515C2.10866 16.4534 2.10995 16.456 2.11152 16.4591C2.11467 16.4653 2.11899 16.4738 2.12446 16.4844C2.13542 16.5057 2.15102 16.5358 2.17123 16.574C2.21166 16.6504 2.27057 16.7595 2.34771 16.8966C2.5019 17.1707 2.72934 17.5577 3.02786 18.0199C3.62366 18.9424 4.50911 20.1749 5.66819 21.4113C7.96812 23.8645 11.4641 26.4546 16 26.4546V24.4546ZM3.88116 16.4729C5.28379 13.859 7.2292 11.5752 9.5869 9.77486L8.3731 8.1853C5.78875 10.1587 3.65632 12.662 2.11884 15.5273L3.88116 16.4729ZM13.7462 7.80282C14.4842 7.63007 15.2398 7.54372 15.9978 7.5455L16.0025 5.5455C15.0895 5.54336 14.1793 5.64737 13.2904 5.85546L13.7462 7.80282ZM16.0001 7.5455C19.737 7.5455 22.741 9.6827 24.8728 11.9567C25.9297 13.084 26.7431 14.2151 27.2922 15.0653C27.5661 15.4894 27.7726 15.8411 27.9093 16.0841C27.9775 16.2055 28.0283 16.2995 28.0611 16.3616C28.0775 16.3926 28.0895 16.4157 28.0969 16.4301C28.1007 16.4374 28.1033 16.4425 28.1047 16.4454C28.1054 16.4468 28.1059 16.4477 28.1061 16.448C28.1061 16.4482 28.1061 16.4482 28.1061 16.4481C28.106 16.448 28.1059 16.4478 28.1059 16.4478C28.1058 16.4475 28.1057 16.4473 29.0001 16C29.8945 15.5528 29.8944 15.5525 29.8942 15.5521C29.8941 15.5519 29.8939 15.5515 29.8937 15.5512C29.8934 15.5505 29.8929 15.5496 29.8924 15.5486C29.8914 15.5467 29.8902 15.5441 29.8886 15.541C29.8854 15.5348 29.8811 15.5263 29.8756 15.5157C29.8647 15.4944 29.8491 15.4643 29.8289 15.4261C29.7885 15.3498 29.7295 15.2407 29.6524 15.1035C29.4982 14.8294 29.2708 14.4425 28.9722 13.9802C28.3765 13.0577 27.491 11.8252 26.3319 10.5888C24.032 8.13558 20.536 5.5455 16.0001 5.5455V7.5455ZM28.1182 15.5286C27.4336 16.8093 26.6172 18.0151 25.6822 19.1262L27.2125 20.4139C28.2371 19.1962 29.1318 17.8749 29.882 16.4715L28.1182 15.5286ZM17.7738 17.8238C17.1392 18.5048 16.1835 18.7851 15.2817 18.5548L14.7868 20.4926C16.3973 20.9039 18.1039 20.4033 19.237 19.1872L17.7738 17.8238ZM15.2817 18.5548C14.3798 18.3244 13.6755 17.6202 13.4452 16.7183L11.5074 17.2132C11.9187 18.8237 13.1763 20.0813 14.7868 20.4926L15.2817 18.5548ZM13.4452 16.7183C13.2149 15.8164 13.4952 14.8607 14.1762 14.2262L12.8128 12.763C11.5967 13.8961 11.0961 15.6027 11.5074 17.2132L13.4452 16.7183Z"
        fill={props.color}
      />
      <path
        d="M3 3L29 29"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVGBase>
  );
};

const FileText: React.FC<IconProps> = (props) => {
  return (
    <SVGBase {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 5.59991C5 3.61168 6.61178 1.99991 8.6 1.99991H19C19.2652 1.99991 19.5196 2.10526 19.7071 2.2928L27.5071 10.0928C27.6946 10.2803 27.8 10.5347 27.8 10.7999V26.3999C27.8 28.3881 26.1882 29.9999 24.2 29.9999H8.6C6.61177 29.9999 5 28.3881 5 26.3999V5.59991ZM8.6 3.99991C7.71634 3.99991 7 4.71625 7 5.59991V26.3999C7 27.2836 7.71635 27.9999 8.6 27.9999H24.2C25.0837 27.9999 25.8 27.2836 25.8 26.3999V11.2141L18.5858 3.99991H8.6Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2001 17.2999C10.2001 16.7476 10.6478 16.2999 11.2001 16.2999H21.6001C22.1524 16.2999 22.6001 16.7476 22.6001 17.2999C22.6001 17.8522 22.1524 18.2999 21.6001 18.2999H11.2001C10.6478 18.2999 10.2001 17.8522 10.2001 17.2999Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2001 22.4999C10.2001 21.9476 10.6478 21.4999 11.2001 21.4999H21.6001C22.1524 21.4999 22.6001 21.9476 22.6001 22.4999C22.6001 23.0522 22.1524 23.4999 21.6001 23.4999H11.2001C10.6478 23.4999 10.2001 23.0522 10.2001 22.4999Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2001 12.1C10.2001 11.5477 10.6478 11.1 11.2001 11.1H13.8001C14.3524 11.1 14.8001 11.5477 14.8001 12.1C14.8001 12.6522 14.3524 13.1 13.8001 13.1H11.2001C10.6478 13.1 10.2001 12.6522 10.2001 12.1Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6173 2.07603C18.991 1.92125 19.4211 2.0068 19.7071 2.2928L27.5071 10.0928C27.7931 10.3788 27.8787 10.8089 27.7239 11.1826C27.5691 11.5563 27.2045 11.7999 26.8 11.7999H20.5C19.1193 11.7999 18 10.6806 18 9.29991V2.99991C18 2.59544 18.2436 2.23081 18.6173 2.07603ZM20 5.41412V9.29991C20 9.57605 20.2239 9.79991 20.5 9.79991H24.3858L20 5.41412Z"
        fill={props.color}
      />
    </SVGBase>
  );
};

const FillOut: React.FC<IconProps> = (props) => {
  return (
    <SVGBase {...props} viewBox="0 0 32 32">
      <path
        fillOpacity="0"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.1323 3L24.6349 8.50265L9.50265 23.6349H4V18.1323L19.1323 3Z"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 28.9683H28.7619"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVGBase>
  );
};

const MegaphoneOn: React.FC<IconProps> = ({ ...props }) => {
  return (
    <SVGBase {...props} viewBox="0 0 28.013 25.972">
      <path d="M27.075 9.238c-1.233-4.47-3.173-7.679-5.321-8.804-.882-.463-1.778-.557-2.585-.274a3.34 3.34 0 0 0-.508.242 3.483 3.483 0 0 0-.625.5L1.701 14.313A4.149 4.149 0 0 0 0 17.676c0 2.269 1.796 4.114 4.004 4.114h.762c.007 2.307 1.955 4.182 4.35 4.182s4.345-1.875 4.352-4.182h10.737a.975.975 0 0 0 .567-.198c.135-.025.282-.037.404-.08 2.398-.84 3.917-4.962 1.9-12.274ZM2 17.676c0-.697.326-1.348.92-1.78L16.45 4.793c-.012.103-.032.192-.042.3l-.016.473c-.012.318-.025.672-.025.714 0 1.917.32 4.136.904 6.248.474 1.723 1.055 3.26 1.726 4.574.602 1.175 1.236 2.04 1.853 2.688H4.004C2.899 19.79 2 18.84 2 17.676Zm7.117 6.296c-1.293 0-2.343-.977-2.351-2.182h4.702c-.008 1.205-1.059 2.182-2.351 2.182Zm15.398-4.347c-.055.02-.132.033-.143.037-.075-.001-1.85-.068-3.595-3.47-.608-1.192-1.14-2.603-1.579-4.195-.536-1.944-.83-3.974-.83-5.708 0-.062.012-.37.022-.65.008-.23.016-.442.015-.45.15-1.625.636-2.428.974-2.8l.332-.273c.005-.004.007-.01.012-.014.035-.02.07-.042.107-.055.276-.098.611-.043.996.159 1.263.66 3.06 2.995 4.321 7.564 1.654 5.992.6 9.423-.632 9.855Z" />
    </SVGBase>
  );
};

const PencilComposeStroke: React.FC<IconProps> = ({ ...props }) => {
  return (
    <SVGBase {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.8739 6.69519C5.02309 6.69519 4.33337 7.38491 4.33337 8.23572V26.0194C4.33337 26.8702 5.02309 27.56 5.8739 27.56H23.6576C24.5084 27.56 25.1981 26.8702 25.1981 26.0194V19.2362C25.1981 18.6839 25.6459 18.2362 26.1981 18.2362C26.7504 18.2362 27.1981 18.6839 27.1981 19.2362V26.0194C27.1981 27.9748 25.613 29.56 23.6576 29.56H5.8739C3.91852 29.56 2.33337 27.9748 2.33337 26.0194V8.23572C2.33337 6.28034 3.91852 4.69519 5.8739 4.69519H12.6571C13.2094 4.69519 13.6571 5.14291 13.6571 5.69519C13.6571 6.24748 13.2094 6.69519 12.6571 6.69519H5.8739Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.1406 5.07885C23.8804 4.81867 23.4586 4.81867 23.1984 5.07885L12.4398 15.8374L11.7166 20.1769L16.056 19.4536L26.8146 8.69503C27.0748 8.43485 27.0748 8.01303 26.8146 7.75285L24.1406 5.07885ZM22.2562 4.13667C23.0368 3.35614 24.3023 3.35614 25.0828 4.13667L27.7568 6.81067C28.5373 7.5912 28.5373 8.85668 27.7568 9.63721L16.8472 20.5468C16.749 20.645 16.6226 20.71 16.4857 20.7328L11.0156 21.6445C10.8034 21.6799 10.5871 21.6106 10.435 21.4585C10.2829 21.3063 10.2136 21.0901 10.2489 20.8778L11.1606 15.4078C11.1834 15.2708 11.2485 15.1444 11.3467 15.0462L22.2562 4.13667Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2736 14.3952C12.4503 14.3952 12.6197 14.4654 12.7447 14.5904L17.3031 19.1487C17.428 19.2737 17.4982 19.4431 17.4982 19.6198C17.4982 19.7965 17.428 19.966 17.3031 20.0909L16.8472 20.5468C16.749 20.645 16.6226 20.71 16.4857 20.7328L11.0156 21.6445C10.8034 21.6799 10.5871 21.6106 10.435 21.4585C10.2829 21.3063 10.2136 21.0901 10.2489 20.8778L11.1606 15.4078C11.1834 15.2708 11.2485 15.1444 11.3467 15.0462L11.8025 14.5904C11.9274 14.4654 12.0969 14.3952 12.2736 14.3952ZM12.3923 16.1224L11.7166 20.1769L15.7711 19.5011L12.3923 16.1224Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9061 20.9874L13.3806 20.5749C13.3806 20.5749 13.3806 18.5128 11.3185 18.5128L10.9061 20.9874Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.2562 4.13667C23.0368 3.35614 24.3023 3.35614 25.0828 4.13667L27.7138 6.76766C28.5191 7.57295 28.4897 8.88735 27.6493 9.65588L25.5615 11.5651L19.9724 6.42054L22.2562 4.13667ZM24.1406 5.07885C23.8804 4.81867 23.4586 4.81867 23.1984 5.07885L21.8966 6.38072L25.5644 9.75682L26.7501 8.67258C27.0302 8.4164 27.04 7.97827 26.7716 7.70984L24.1406 5.07885Z"
        fill={props.color}
      />
    </SVGBase>
  );
};

const PlusCircle: React.FC<IconProps> = ({ ...props }) => {
  return (
    <SVGBase {...props} viewBox="0 0 18 18">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5ZM0.25 9C0.25 4.16751 4.16751 0.25 9 0.25C13.8325 0.25 17.75 4.16751 17.75 9C17.75 13.8325 13.8325 17.75 9 17.75C4.16751 17.75 0.25 13.8325 0.25 9Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 4.95276C9.34518 4.95276 9.625 5.23258 9.625 5.57776V12.4222C9.625 12.7674 9.34518 13.0472 9 13.0472C8.65482 13.0472 8.375 12.7674 8.375 12.4222V5.57776C8.375 5.23258 8.65482 4.95276 9 4.95276Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.95276 8.99996C4.95276 8.65478 5.23258 8.37496 5.57776 8.37496H12.4222C12.7674 8.37496 13.0472 8.65478 13.0472 8.99996C13.0472 9.34514 12.7674 9.62496 12.4222 9.62496H5.57776C5.23258 9.62496 4.95276 9.34514 4.95276 8.99996Z"
        fill={props.color}
      />
    </SVGBase>
  );
};

const StrikedThroughSpeechBubble: React.FC<IconProps> = ({ ...props }) => {
  return (
    <SVGBase {...props} viewBox="0 0 16 16">
      <path
        d="M8.25544 2.67392H8.59784C11.5532 2.83697 13.9131 5.19679 14.0761 8.15219V8.49458M4.39389 4.14129C3.1662 5.22985 2.43544 6.80663 2.43478 8.49458C2.43263 9.3189 2.6081 10.1331 2.94813 10.8819C3.01288 11.0246 3.05195 11.1781 3.03262 11.3336C2.9748 11.7982 2.73604 12.852 1.75 13.6305C3.17332 14.3421 4.49803 14.1005 5.17755 13.885C5.48388 13.7878 5.82115 13.7903 6.11977 13.909C6.79782 14.1787 7.52261 14.3171 8.25544 14.3152C10.0291 14.3146 11.68 13.5077 12.7707 12.1653"
        stroke="currentColor"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <line
        x1="14.5429"
        y1="13.8261"
        x2="2.9239"
        y2="2.20711"
        stroke="currentColor"
        stroke-linecap="round"
      />
    </SVGBase>
  );
};

const Survey: React.FC<IconProps> = (props) => {
  return (
    <SVGBase {...props} viewBox="0 0 24 24">
      <rect width="24" height="24" rx="4" fill={props.color} />
      <circle cx="6.75" cy="8.25" r="0.75" fill="white" />
      <circle cx="6.75" cy="11.9175" r="0.75" fill="white" />
      <circle cx="6.75" cy="15.585" r="0.75" fill="white" />
      <rect x="9" y="7.5" width="9" height="1.5" rx="0.75" fill="white" />
      <rect x="9" y="11.25" width="9" height="1.5" rx="0.75" fill="white" />
      <rect x="9" y="15" width="9" height="1.5" rx="0.75" fill="white" />
    </SVGBase>
  );
};

const Template: React.FC<IconProps> = (props) => {
  return (
    <SVGBase {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.84322 2L10.409 2C10.9613 2 11.409 2.44772 11.409 3C11.409 3.55228 10.9613 4 10.409 4H8.88176C8.30521 4 7.93294 4.00078 7.6496 4.02393C7.37794 4.04612 7.27722 4.0838 7.22777 4.10899C7.03961 4.20487 6.88663 4.35785 6.79076 4.54601C6.76557 4.59545 6.72789 4.69617 6.70569 4.96784C6.68254 5.25117 6.68176 5.62345 6.68176 6.2V7.72727C6.68176 8.27956 6.23405 8.72727 5.68176 8.72727C5.12948 8.72727 4.68176 8.27956 4.68176 7.72727L4.68176 6.16146C4.68175 5.63431 4.68173 5.17954 4.71233 4.80497C4.74463 4.40963 4.81595 4.01641 5.00874 3.63803C5.29637 3.07354 5.75531 2.6146 6.31979 2.32698C6.69817 2.13419 7.09139 2.06287 7.48674 2.03057C7.86131 1.99997 8.31607 1.99998 8.84322 2Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.84322 30L10.409 30C10.9613 30 11.409 29.5523 11.409 29C11.409 28.4477 10.9613 28 10.409 28H8.88176C8.30521 28 7.93294 27.9992 7.6496 27.9761C7.37794 27.9539 7.27722 27.9162 7.22777 27.891C7.03961 27.7952 6.88663 27.6422 6.79076 27.454C6.76557 27.4046 6.72789 27.3039 6.70569 27.0322C6.68254 26.7489 6.68176 26.3766 6.68176 25.8V24.2728C6.68176 23.7205 6.23405 23.2728 5.68176 23.2728C5.12948 23.2728 4.68176 23.7205 4.68176 24.2728L4.68176 25.8386C4.68175 26.3657 4.68173 26.8205 4.71233 27.1951C4.74463 27.5904 4.81595 27.9836 5.00874 28.362C5.29637 28.9265 5.75531 29.3854 6.31979 29.673C6.69817 29.8658 7.09139 29.9372 7.48674 29.9695C7.86131 30.0001 8.31607 30 8.84322 30Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.7931 30L22.2273 30C21.675 30 21.2273 29.5523 21.2273 29C21.2273 28.4477 21.675 28 22.2273 28H23.7546C24.3311 28 24.7034 27.9992 24.9867 27.9761C25.2584 27.9539 25.3591 27.9162 25.4086 27.891C25.5967 27.7952 25.7497 27.6422 25.8456 27.454C25.8708 27.4046 25.9084 27.3039 25.9306 27.0322C25.9538 26.7489 25.9546 26.3766 25.9546 25.8V24.2728C25.9546 23.7205 26.4023 23.2728 26.9546 23.2728C27.5068 23.2728 27.9546 23.7205 27.9546 24.2728L27.9546 25.8386C27.9546 26.3657 27.9546 26.8205 27.924 27.1951C27.8917 27.5904 27.8204 27.9836 27.6276 28.362C27.34 28.9265 26.881 29.3854 26.3165 29.673C25.9382 29.8658 25.5449 29.9372 25.1496 29.9695C24.775 30.0001 24.3203 30 23.7931 30Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.8636 21.9091C20.8636 22.4614 20.4158 22.9091 19.8636 22.9091H12.7726C12.2204 22.9091 11.7726 22.4614 11.7726 21.9091C11.7726 21.3568 12.2204 20.9091 12.7726 20.9091H19.8636C20.4158 20.9091 20.8636 21.3568 20.8636 21.9091Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.8636 17.1818C20.8636 17.7341 20.4158 18.1818 19.8636 18.1818H12.7726C12.2204 18.1818 11.7726 17.7341 11.7726 17.1818C11.7726 16.6296 12.2204 16.1818 12.7726 16.1818H19.8636C20.4158 16.1818 20.8636 16.6296 20.8636 17.1818Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3182 12.4546C17.3182 13.0069 16.8705 13.4546 16.3182 13.4546H12.7727C12.2204 13.4546 11.7727 13.0069 11.7727 12.4546C11.7727 11.9023 12.2204 11.4546 12.7727 11.4546H16.3182C16.8705 11.4546 17.3182 11.9023 17.3182 12.4546Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5454 29C13.5454 28.4477 13.9931 28 14.5454 28H18.0909C18.6432 28 19.0909 28.4477 19.0909 29C19.0909 29.5523 18.6432 30 18.0909 30H14.5454C13.9931 30 13.5454 29.5523 13.5454 29Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5454 3C13.5454 2.44772 13.9931 2 14.5454 2H18.0909C18.6432 2 19.0909 2.44772 19.0909 3C19.0909 3.55228 18.6432 4 18.0909 4H14.5454C13.9931 4 13.5454 3.55228 13.5454 3Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.68176 10.8636C6.23405 10.8636 6.68176 11.3114 6.68176 11.8636L6.68176 20.1364C6.68176 20.6887 6.23405 21.1364 5.68176 21.1364C5.12948 21.1364 4.68176 20.6887 4.68176 20.1364L4.68176 11.8636C4.68176 11.3114 5.12948 10.8636 5.68176 10.8636Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.9546 13.8182C26.4023 13.8182 25.9546 14.2659 25.9546 14.8182V20.7273C25.9546 21.2796 26.4023 21.7273 26.9546 21.7273C27.5068 21.7273 27.9546 21.2796 27.9546 20.7273V14.8182C27.9546 14.2659 27.5068 13.8182 26.9546 13.8182Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.9772 6.5455C29.9772 7.23586 29.4176 7.7955 28.7272 7.7955H21.6363C20.946 7.7955 20.3863 7.23586 20.3863 6.5455C20.3863 5.85515 20.946 5.2955 21.6363 5.2955H28.7272C29.4176 5.2955 29.9772 5.85515 29.9772 6.5455Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.1818 1.75C25.8722 1.75 26.4318 2.30964 26.4318 3V10.0909C26.4318 10.7813 25.8722 11.3409 25.1818 11.3409C24.4915 11.3409 23.9318 10.7813 23.9318 10.0909V3C23.9318 2.30964 24.4915 1.75 25.1818 1.75Z"
        fill={props.color}
      />
    </SVGBase>
  );
};

const Award: React.FC<IconProps> = (props) => {
  return (
    <SVGBase {...props} viewBox="0 0 16 24">
      <path
        id="Oval"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
        fill={'#FF000000'}
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Shape"
        d="M4.21 13.89L3 23L8 20L13 23L11.79 13.88"
        fill={'#FF000000'}
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVGBase>
  );
};

const NoSms: React.FC<IconProps> = (props) => {
  return (
    <SVGBase {...props} viewBox="0 0 41 40">
      <rect x="0.455444" width="40" height="40" rx="20" fill="#F2F3F5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6265 9.64507C16.0779 9.22339 16.7158 9 17.4691 9H25.4391C27.0152 9 27.9792 10.4898 27.9792 11.8987L27.9517 21.1943C27.9514 21.2694 27.908 21.3378 27.8401 21.3699C27.7722 21.4021 27.6918 21.3924 27.6335 21.3449L26.159 20.1437C26.1135 20.1067 26.0871 20.0512 26.0871 19.9925V11.8987C26.0871 11.1628 25.6337 10.8921 25.4391 10.8921H17.4691C17.2745 10.8921 16.8211 11.1628 16.8211 11.8987V11.9149L16.7604 12.6366C16.7544 12.7088 16.7089 12.7717 16.6422 12.7999C16.5755 12.8282 16.4986 12.8172 16.4425 12.7713L14.9995 11.5896C14.9542 11.5526 14.928 11.4972 14.928 11.4388V11.3956C14.928 10.6729 15.1737 10.0682 15.6265 9.64507ZM14.9291 16.7049L9.83539 12.6299C9.39884 12.2807 9.32806 11.6437 9.6773 11.2071C10.0265 10.7706 10.6636 10.6998 11.1001 11.049L31.3455 27.2454C31.7821 27.5946 31.8528 28.2316 31.5036 28.6682C31.1543 29.1047 30.5173 29.1755 30.0808 28.8263L27.9522 27.1234L27.9521 28.6642C27.9521 28.9265 27.8367 29.1677 27.6708 29.3737C27.5046 29.5801 27.2785 29.7634 27.0308 29.9155C26.5391 30.2173 25.9246 30.4187 25.4391 30.4187H17.4691C15.893 30.4187 14.9291 28.9289 14.9291 27.52V16.7049ZM26.0871 25.6313V27.4159C26.0871 27.7809 25.9723 28.066 25.8288 28.2563C25.678 28.4563 25.5182 28.5266 25.4391 28.5266H17.4691C17.2745 28.5266 16.8211 28.2556 16.8211 27.5196V18.2185L26.0871 25.6313ZM21.32 25.5225C20.6938 25.5225 20.1862 26.0301 20.1862 26.6563C20.1862 27.2825 20.6938 27.7901 21.32 27.7901C21.9462 27.7901 22.4538 27.2825 22.4538 26.6563C22.4538 26.0301 21.9462 25.5225 21.32 25.5225Z"
        fill="#656565"
      />
    </SVGBase>
  );
};

const PersonPlus: React.FC<IconProps> = (props) => {
  return (
    <SVGBase {...props} viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.875 15.0292C1.875 12.9693 3.32465 11.1294 5.30702 11.1294H10.2193C12.2017 11.1294 13.6513 12.9693 13.6513 15.0292V16.6667C13.6513 17.0119 13.3715 17.2917 13.0263 17.2917H2.5C2.15482 17.2917 1.875 17.0119 1.875 16.6667V15.0292H2.5L3.125 15.0293V16.0417H12.4013V15.0293C12.4013 13.472 11.3375 12.3794 10.2193 12.3794H5.30702C4.18884 12.3794 3.125 13.4719 3.125 15.0293L2.5 15.0292H1.875Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.33118 6.14036C4.33118 4.24491 5.86774 2.70834 7.76319 2.70834C9.65865 2.70834 11.1952 4.24491 11.1952 6.14036C11.1952 8.03581 9.65865 9.57238 7.76319 9.57238C5.86774 9.57238 4.33118 8.03581 4.33118 6.14036ZM7.76319 3.95834C6.5581 3.95834 5.58118 4.93527 5.58118 6.14036C5.58118 7.34546 6.5581 8.32238 7.76319 8.32238C8.96829 8.32238 9.94521 7.34546 9.94521 6.14036C9.94521 4.93527 8.96829 3.95834 7.76319 3.95834Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8333 6.21713C16.1785 6.21713 16.4583 6.49695 16.4583 6.84213V11.0527C16.4583 11.3978 16.1785 11.6777 15.8333 11.6777C15.4881 11.6777 15.2083 11.3978 15.2083 11.0527V6.84213C15.2083 6.49695 15.4881 6.21713 15.8333 6.21713Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.103 8.94739C13.103 8.60221 13.3828 8.32239 13.728 8.32239H17.9385C18.2837 8.32239 18.5635 8.60221 18.5635 8.94739C18.5635 9.29257 18.2837 9.57239 17.9385 9.57239H13.728C13.3828 9.57239 13.103 9.29257 13.103 8.94739Z"
        fill={props.color}
      />
    </SVGBase>
  );
};

/**
 * An object that sources correct svg components for use in Icon.tsx
 *
 * Add new svg components:
 *  * Find the source svg [in Figma](https://www.figma.com/file/ZKdFL37CtUUAMOQg9Jas5Stf/%5BRDL%5D-Assets?node-id=983%3A924)
 *  * Select it (make sure it's not a `path`; may have to click to scope to the "Parent component" - the icon should have a name)
 *  * Right-click & select "Copy as SVG"
 *  * Return here & paste the svg following the pattern of the other svg components
 *    * Wrap the svg with `SVGBase`, make sure the viewbox matches what you pasted, & delete the `<svg...>` & `</svg>` lines
 *    * Make sure any internal attribute names follow react convention with camelCase & not kebob-case as multi-word attributes are in HTML/Figma
 *      * e.g. `stroke-width` must be `strokeWidth`; you'll see warnings in the console if these aren't updated
 *    * replace relevant `fill` attributes with `{props.color}`
 *    * check with design if the svg utilizes `stroke`s instead of `fill`s - it may be outdated
 *      * if `stroke` is necessary, replace relevant `stroke` attributes with `currentColor`
 *  * Add the new component to the default export
 *
 * @param {object} props
 * @param {string} props.altText: accessible description to be applied as a child of the <title> tag; use something that's as meaningful as the icon's visual description; if the icon has a label, please leave the alt text blank or screenreaders will announce the label twice
 * @param {string} props.ariaHidden: Hide this icon from screen readers; when the icon is supplemental to info that is already conveyed via text, like in `TextWithIcon`
 * @param {string} props.name: kebab-case name of the svg to render; possible names can be found in `IconConstants.ts` (`ICONS`) or `svgs.tsx` (`svgs`)
 * @param {string} props.color: colors are applied via css; this is possible because we're rendering svg html, not img tags
 * @param {string} props.size: same as above
 */
const svgs = {
  'arrow-right': ArrowRight,
  'bell-blue': BellBlue,
  download: Download,
  ellipses: Ellipses,
  'ellipses-animated': EllipsesAnimated,
  'eye-off': EyeOff,
  'file-text': FileText,
  'fill-out': FillOut,
  'megaphone-on': MegaphoneOn,
  'pencil-compose-stroke': PencilComposeStroke,
  'plus-circle': PlusCircle,
  'striked-through-speech-bubble': StrikedThroughSpeechBubble,
  survey: Survey,
  template: Template,
  award: Award,
  'no-sms': NoSms,
  person_plus: PersonPlus,
};

export default svgs;
